<template>
  <div >
    <div class="gameplay_title_container">

      <div class="gameplay_title">
        {{ getTranslations.home_game_memory_name_question_one }}      </div>
    </div>

    <div class="gameplay_game_box_list gameplay_tap_box memory7" >
      <div class="gameplay_btns_row" v-for="(row, rowindex) in twoDimensionalTable" :key="rowindex">
        <div  type="" class="names_box" v-for="(col, colindex) in row"
                :key="rowindex-colindex"
                :ref="rowindex === 0 ? (colindex + 1) : (rowindex * numOfCols) + (colindex + 1)">
          <img :src=col.img>
          <p>{{col.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'MemoryNames',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      timeToViewTheList: null,
      numOfCols: 0,
      numOfRow: 0,
      twoDimensionalTable: [],
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    this.getTheFinalList();
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      this.numOfRow = this.gameInfo.nameImagesDTO.length / 2;
      this.numOfCols = 2;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      let index = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.gameInfo.nameImagesDTO[index];
          index += 1;
        }
      }
    },
    getTheFinalList() {
      setTimeout(() => {
        this.changeBrainiacMiniGameType('MEMORY_NAMES_QUIZ');
      }, this.gameInfo.timer);
    },
    changeQuestionText() {
      if (this.timeToViewTheList === true) {
        return this.gameInfo.question;
      }
      return 'Watch the image carefully You will answer a question.';
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryNames.vue